import '@availity/yup';
import * as yup from 'yup';

const phone = yup.string().matches(/^\+?[\d\s().-]{6,20}$/, {
  message: 'Invalid phone number',
  excludeEmptyString: true,
});

const formValidation = yup.object().shape({
  name: yup.string().required(),
  landingTemplateId: yup.string().required(),
  campaignId: yup.string().required(),
  description: yup.string(),
  landingComponents: yup.object().shape({
    callback_or_call: yup.object().shape({ phoneNumber: phone }),
    click_to_call: yup.object().shape({ phoneNumber: phone }),
  }),
});

export default formValidation;
